import { modules } from "@core/utils/modules.js";
import BookeepingMain from "@/views/bookeeping/views/BookeepingMain.vue";
// import DiscountRoute from "@/views/bookeeping/views/discounts/discounts.router.js";
import AccountingAccountsRoute from "@/views/bookeeping/views/accounting-accounts/accounting-accounts.router.js";
import TransactionsRoute from "@/views/bookeeping/views/transactions/transactions.router.js";
import BookeepingAttendance from "@/views/bookeeping/views/bookeeping-attendance/router/bookeeping-attendance.route.js";

const routes = [
    {
        path: "/bookeeping",
        name: "bookeeping",
        redirect: { name: "bookeeping-accounting-accounts" },
        meta: { module: modules.BOOKEEPING },
        component: BookeepingMain,
        children: [
            // ...DiscountRoute,
            ...AccountingAccountsRoute,
            ...TransactionsRoute,
            ...BookeepingAttendance
        ]
    }
]
export default routes;